import { render, staticRenderFns } from "./GamesIntegrationList.vue?vue&type=template&id=69847e5a&scoped=true&"
import script from "./GamesIntegrationList.vue?vue&type=script&lang=js&"
export * from "./GamesIntegrationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69847e5a",
  null
  
)

export default component.exports